import { XIcon } from "@heroicons/react/solid";
import React, {useEffect, useState } from "react";
import { v4 as uuid } from "uuid";

export default function AddNewGroup({close, type, editData}) {

  const [isPrimary, setIsPrimary] = useState();
  const [data, setData] = useState({
    is_primary: type==='New'? 'N': editData.is_primary,
    outlet_uuid: type==='New'? []: editData.outlet_uuid,
    warehouse_title: type==='New'? '': editData.warehouse_title,
    warehouse_uuid: type==='New'? '': editData.warehouse_uuid,
  });

  useEffect(() => {
    const getPrimaryWarehouse = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/invWarehouse/GetPrimaryWarehouse`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
      .then(res => res.json())
      .then(data => {
        if(data && data.success){
          setIsPrimary(data.result[0]);
          // console.log(data.result[0])
        }
      })
      .catch(err => console.warn("post request failed", err));
    }
    getPrimaryWarehouse();
  }, []);

  const handleSave = async (e)=>{
    e.preventDefault();
    data.outlet_uuid.push(localStorage.getItem("outlet_uuid"));
    const json = {
      is_primary: data.is_primary,
      outlet_uuid: data.outlet_uuid,
      warehouse_title: data.warehouse_title,
      warehouse_uuid: uuid(),
    }
    const url = `https://api.myfooddo.com/invWarehouse/CreateWarehouse`;
    
    if(json.is_primary==='Y' && isPrimary){
      alert('primary warehouse already exists')
      setData({...data, is_primary: 'N',})
      json.is_primary='N';
    }
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify([json]),
    })
    .then(res => res.json())
    .then(data => {
      console.log("CreateWarehouse succeeded...", data);
    })
    .catch(err => console.warn("post request failed", err));
    close()
  }

  const handleEdit = async (e)=>{
    e.preventDefault();
    const json = {
      is_primary: data.is_primary,
      outlet_uuid: data.outlet_uuid,
      warehouse_title: data.warehouse_title,
      warehouse_uuid: data.warehouse_uuid.toString(),
    }
    const url = `https://api.myfooddo.com/invWarehouse/EditWarehouse`;
    
    if(json.is_primary==='Y' && isPrimary){
      alert('primary warehouse already exists')
      setData({...data, is_primary: 'N',})
      json.is_primary='N';
    }
    console.log(url, json);
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify([json]),
    })
    .then(res => res.json())
    .then(data => {
      console.log("EditWarehouse...", data);
    })
    .catch(err => console.warn("post request failed", err));
    close()
  }
  
  return (
    <div className='newCategory' draggable={false}>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Warehouse</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <form className='newCatContainer2' action='' onSubmit={type==='New'? handleSave : handleEdit}>
          <div className='cat-inp'>
            <label htmlFor='title'>Title</label>
            <input
              value={data.warehouse_title}
              onChange={e =>setData({
                ...data,
                warehouse_title: e.target.value,
              })}
              maxLength={40}
              type='text'
              required
              id='title'
            />
          </div>
          <div className='cat-inp'>
            <label htmlFor='ledgerGroup'>IsPrimary</label>
            <select
              value={data.is_primary}
              onChange={e =>setData({
                ...data,
                is_primary: e.target.value,
              })}
            >
              <option value='Y'>Yes</option>
              <option value='N'>No</option>
            </select>
          </div>
          {type === "New" ? (
            <button type='submit' >Save</button>
          ) : (
            <button type='submit' >Update</button>
          )}
        </form>
      </div>
    </div>
  );
}
